import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-plans',
  templateUrl: './shared-plans.component.html',
  styleUrls: ['./shared-plans.component.scss']
})
export class SharedPlansComponent implements OnInit {
  sectionTitle = 'Shared Plans'
  SPData = {
    plansView: 'Here you can view all of the plans that others have chosen to share with you.',
    sharedPlansInfo: '7 plans have been shared with you.',
    name: 'Sam Tarly'
  }
  SPCategories = [
    {
      fa: 'fa fa-2x fas fa-tachometer-alt',
      boxTitle: 'Dashboard'
    },
    {
      fa: 'fa fa-2x fas fa-home',
      boxTitle: 'Assets'
    },
    {
      fa: 'fa fa-2x fas fa-credit-card',
      boxTitle: 'Debts'
    },
    {
      fa: 'fa fa-2x fas fa-shoe-prints',
      boxTitle: 'Dayli Life'
    },
    {
      fa: 'fa fa-2x fas fa-handshake',
      boxTitle: 'Wishes'
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
